import APIClient from '../factories/APIClient'
import constructRequestData from '../../constructRequestData'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Login.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'post /login': 200,
    // 'post /login/facebook': 200,
    // 'post /login/google': 200,
    // 'post /user/logout': 200,
  })
}

export const postClientVerify = ({ clientId, redirectUri }) => {
  return client({
    method: 'post',
    url: '/client/verify',
    data: constructRequestData({ clientId, redirectUri }),
  })
}
